module.exports = __webpack_public_path__ + "img/5b5e4c8.jpg";